// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SchemaProp_wrapper__28w6s"};